import axios from 'axios';
export const api=axios.create({baseURL:process.env.REACT_APP_BACKEND_URL+'/api',withCredentials:true});
export const errorText=e=>typeof e.response?.data?.detail==='string'?e.response.data.detail:'Please check the details and try again.';
export const track=event=>api.post('/events',{event}).catch(()=>{});
export const money=value=>new Intl.NumberFormat('en-AE',{maximumFractionDigits:0}).format(value||0);
export const date=value=>value?new Date(value).toLocaleDateString('en-GB',{day:'2-digit',month:'short',year:'numeric'}):'—';